import { useEffect, useState } from 'react';
import {
  ensureStatusLookup,
  resolveStatusColor,
  subscribeStatusLookup,
} from '../services/statusLookup';

/** Resolves status Color from StatusInDropDown (shared app-wide cache). */
export function useStatusColor({ color, name, statusId, status } = {}) {
  const [, setTick] = useState(0);

  useEffect(() => {
    ensureStatusLookup();
    return subscribeStatusLookup(() => setTick((n) => n + 1));
  }, []);

  return resolveStatusColor({ color, name, statusId, status });
}

export default useStatusColor;
